import ModeOutlinedIcon from "@mui/icons-material/ModeOutlined";
import { Box, IconButton } from "@mui/material";
import SideSheetDrawer from "../../../../../components/SidesheetDrawer";
import { DisclosureHost } from "../../../../../hooks/use-disclosure";
import { Form } from "react-formio";
import LoadingOverlay from "../../../../../components/LoadingOverlay";

interface PreviewFormDrawerProps {
  disClosureHost: DisclosureHost;
  title: string;
  schema?: any;
  onEdit?: (schema: any) => void;
  isLoading?: boolean;
  shouldEdit?: boolean;
}

/**
 *
 * @returns preview form builder
 * @author rajkumar rathod
 */
const PreviewFormDrawer = ({
  isLoading,
  disClosureHost,
  title,
  schema,
  onEdit,
  shouldEdit,
}: PreviewFormDrawerProps) => {
  return (
    <SideSheetDrawer
      title={title}
      open={disClosureHost.opened}
      onClose={disClosureHost.close}
      w={"50vw"}
      endIcon={
        shouldEdit ? (
          <IconButton onClick={() => onEdit?.(schema)}>
            <ModeOutlinedIcon />
          </IconButton>
        ) : undefined
      }
    >
      <LoadingOverlay isLoading={!!isLoading} />

      <Box width={"100%"}>
        <Form form={schema} options={{ readOnly: true }} />
      </Box>
    </SideSheetDrawer>
  );
};

export default PreviewFormDrawer;
